import * as React from 'react'

const NiboIcon = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={15}
    height={15}
    viewBox="15.624 15.396 149.102 149.102"
    {...props}
  >
    <path
      fill="#2082A3"
      d="M76.375 16.063c1.747-.282 3.458-.563 5.125-.563v30c-28.115 9.043-39.281 29.543-33.833 58.833-.657.546-17.426 10.101-25.167 15.167-2.108-2.657-3.348-5.257-4.333-8.5-.824-2.712-1.333-5.417-1.667-7.5a97.207 97.207 0 0 1 0-27c.417-2.583 1-4.417 2-7 9.135-28.801 28.344-46.905 57.875-53.437z"
    />
    <path
      fill="#2FBAE7"
      d="M98.5 15.5c35.719 6.552 57.552 27.552 65.5 63 2.13 14.412-.036 28.078-6.5 41a449.63 449.63 0 0 0-22-12.5c-1.49-.745-2.49-1.912-3-3.5 5.583-21.651-.75-38.818-19-51.5a45.233 45.233 0 0 0-15-5.5v-31z"
    />
    <path
      fill="#29A5CE"
      d="M74.5 131.5c1.777 1.1 3.777 1.934 6 2.5 6.181.819 12.181.653 18-.5 9.763-2.463 18.263-7.129 25.5-14 8.07 4.62 16.237 9.12 24.5 13.5.951.718 1.117 1.551.5 2.5-12.781 15.745-29.281 25.245-49.5 28.5-28.505 2.741-51.505-7.093-69-29.5a157.233 157.233 0 0 1 25-15 190.91 190.91 0 0 0 13 9.5 23.423 23.423 0 0 0 6 2.5z"
    />
  </svg>
)
export default NiboIcon
